/* ============================================================
   assets/animations.js
   Women's Fashion – Shopify Theme Animation Engine
   ============================================================ */

(function () {
  'use strict';

  /* --------------------------------------------------------
     1. PAGE LOADER
     -------------------------------------------------------- */
  function initLoader() {
    var loader  = document.getElementById('page-loader');
    var bar     = document.getElementById('loader-progress-bar');
    var canvas  = document.getElementById('loader-canvas');
    if (!loader) return;

    var isHome = document.body.classList.contains('template-index');

    /* Silk ripple canvas */
    if (canvas) {
      var ctx    = canvas.getContext('2d');
      var W, H, t = 0;
      function resize() {
        W = canvas.width  = canvas.offsetWidth;
        H = canvas.height = canvas.offsetHeight;
      }
      resize();
      window.addEventListener('resize', resize);

      var waves = Array.from({ length: 6 }, function (_, i) {
        return {
          amp:    60 + i * 20,
          freq:   0.003 + i * 0.001,
          speed:  0.012 + i * 0.004,
          phase:  (i / 6) * Math.PI * 2,
          color:  'rgba(142,105,103,' + (0.04 + i * 0.015) + ')'
        };
      });

      function drawWaves() {
        ctx.clearRect(0, 0, W, H);
        waves.forEach(function (w) {
          ctx.beginPath();
          for (var x = 0; x <= W; x += 3) {
            var y = H / 2 + Math.sin(x * w.freq + t * w.speed + w.phase) * w.amp
                          + Math.sin(x * w.freq * 0.5 + t * w.speed * 1.3) * (w.amp * 0.4);
            x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
          }
          ctx.lineTo(W, H);
          ctx.lineTo(0, H);
          ctx.closePath();
          ctx.fillStyle = w.color;
          ctx.fill();
        });
        t++;
        if (!loader.classList.contains('loader-hidden')) requestAnimationFrame(drawWaves);
      }
      requestAnimationFrame(drawWaves);
    }

    /* Progress bar */
    if (bar) {
      setTimeout(function () { bar.style.width = '100%'; }, 100);
    }

    /* Hide loader */
    if (isHome) {
      /* Homepage: smooth 2.4s branded loader */
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        loader.classList.add('loader-hidden');
        document.body.style.overflow = '';
      }, 2400);
    } else {
      /* Inner pages: smooth 2.4s branded loader */
      document.body.style.overflow = 'hidden';
      var hideInner = function() {
        loader.classList.add('loader-hidden');
        document.body.style.overflow = '';
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(hideInner, 2400);
        });
      } else {
        setTimeout(hideInner, 2400);
      }
    }

    /* SBD v6 bfcache loader safety */
    window.addEventListener('pageshow', function(e){
      if (!e.persisted) return;
      loader.classList.add('loader-hidden');
      document.body.style.overflow = '';
    });
  }

  /* --------------------------------------------------------
     2. SCROLL-BASED HEADER
     -------------------------------------------------------- */
  function initHeader() {
    var header = document.getElementById('site-header');
    if (!header) return;
    var lastScroll = 0;
    var scrolled = false;

    window.addEventListener('scroll', function () {
      var s = window.scrollY;
      if (s > 60 && !scrolled) {
        header.classList.add('scrolled');
        scrolled = true;
      } else if (s <= 60 && scrolled) {
        header.classList.remove('scrolled');
        scrolled = false;
      }
      lastScroll = s;
    }, { passive: true });
  }

  /* --------------------------------------------------------
     3. GENERIC SCROLL REVEAL (IntersectionObserver)
     -------------------------------------------------------- */
  function initScrollReveal() {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var options = { threshold: 0.1, rootMargin: '0px 0px -60px 0px' };

    /* [data-animate] elements */
    var animEls = document.querySelectorAll('[data-animate]');
    if (animEls.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var delay = e.target.dataset.delay || 0;
            setTimeout(function () {
              e.target.classList.add('animated');
            }, parseInt(delay));
            observer.unobserve(e.target);
          }
        });
      }, options);
      animEls.forEach(function (el) { observer.observe(el); });
    }

    /* class-based: footer cols, cart items, feature cards, product cards, collection cards */
    var classTargets = [
      { selector: '.footer-col',       cls: 'in-view' },
      { selector: '.footer-bottom',    cls: 'in-view' },
      { selector: '.cart-item',        cls: 'in-view' },
      { selector: '.feature-card',     cls: 'in-view' },
      { selector: '.product-card',     cls: 'in-view' },
      { selector: '.collection-card',  cls: 'in-view' },
      { selector: '.cta-content',      cls: 'in-view' },
      { selector: '.marquee-section',  cls: 'in-view' },
    ];

    classTargets.forEach(function (t) {
      var els = document.querySelectorAll(t.selector);
      if (!els.length) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add(t.cls);
            obs.unobserve(e.target);
          }
        });
      }, options);
      els.forEach(function (el) { obs.observe(el); });
    });
  }

  /* --------------------------------------------------------
     4. PARALLAX (visual break section)
     -------------------------------------------------------- */
  function initParallax() {
    var els = document.querySelectorAll('.visual-break-img');
    if (!els.length) return;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    window.addEventListener('scroll', function () {
      var s = window.scrollY;
      els.forEach(function (img) {
        var rect = img.closest('.visual-break').getBoundingClientRect();
        var progress = -rect.top / window.innerHeight;
        img.style.transform = 'translateY(' + (progress * 40) + 'px)';
      });
    }, { passive: true });
  }

  /* --------------------------------------------------------
     5. CUSTOM CURSOR (desktop only)
     -------------------------------------------------------- */
  function initCursor() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var dot  = document.getElementById('cursor-dot');
    var ring = document.getElementById('cursor-ring');
    if (!dot || !ring) return;

    var mx = 0, my = 0, rx = 0, ry = 0;
    var raf;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left  = mx + 'px';
      dot.style.top   = my + 'px';
    });

    function animate() {
      rx += (mx - rx) * 0.14;
      ry += (my - ry) * 0.14;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      raf = requestAnimationFrame(animate);
    }
    animate();

    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, .btn, .icon-btn, input, textarea, select')) {
        document.body.classList.add('cursor-hover');
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('a, button, .btn, .icon-btn, input, textarea, select')) {
        document.body.classList.remove('cursor-hover');
      }
    });
    document.addEventListener('mousedown', function () {
      document.body.classList.add('cursor-click');
    });
    document.addEventListener('mouseup', function () {
      document.body.classList.remove('cursor-click');
    });
  }

  /* --------------------------------------------------------
     6. PAGE TRANSITION (link clicks)
     -------------------------------------------------------- */
  function initPageTransition() {
    var overlay = document.getElementById('page-transition');
    if (!overlay) return;

    /*
      SBD fix:
      Do not intercept normal internal links with preventDefault().
      Let the browser handle navigation and history naturally, so Back goes
      to the previous page instead of replaying/reloading the same URL.
    */
    overlay.classList.remove('entering', 'leaving');

    window.addEventListener('pageshow', function () {
      overlay.classList.remove('entering', 'leaving');
      var loader = document.getElementById('page-loader');
      if (loader) {
        loader.classList.add('loader-hidden');
        document.body.style.overflow = '';
      }
    });

    window.addEventListener('pagehide', function () {
      overlay.classList.remove('entering', 'leaving');
    });
  }

  /* --------------------------------------------------------
     7. STAT COUNTER ANIMATION (about page)
     -------------------------------------------------------- */
  function initStatCounters() {
    var stats = document.querySelectorAll('.about-stat-value');
    if (!stats.length) return;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        var el  = e.target;
        var raw = el.textContent.trim();
        var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
        var suffix = raw.replace(/[0-9.]/g, '');
        if (isNaN(num)) return;
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var p = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var current = start + (num - start) * eased;
          el.textContent = (Number.isInteger(num) ? Math.round(current) : current.toFixed(1)) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    stats.forEach(function (el) { obs.observe(el); });
  }

  /* --------------------------------------------------------
     8. CART ITEM REMOVE ANIMATION
     -------------------------------------------------------- */
  function initCartAnimations() {
    var removeLinks = document.querySelectorAll('.cart-item a[href*="quantity=0"]');
    removeLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var item = link.closest('.cart-item');
        if (item) {
          item.style.transition = 'all 0.35s ease';
          item.style.opacity    = '0';
          item.style.transform  = 'translateX(-40px)';
          item.style.maxHeight  = item.offsetHeight + 'px';
          setTimeout(function () {
            item.style.maxHeight = '0';
            item.style.margin    = '0';
            item.style.padding   = '0';
          }, 200);
        }
      });
    });
  }

  /* --------------------------------------------------------
     9. HEADER LOGO CHAR SPLIT (on load, if text)
     -------------------------------------------------------- */
  function initLoaderChars() {
    var brandEl = document.querySelector('.loader-brand');
    if (!brandEl) return;

    /* SBD v6: do not split/clear image logos. This prevents the logo-pop flicker. */
    if (brandEl.querySelector('img')) return;

    var text = brandEl.textContent.trim();
    if (!text) return;

    brandEl.innerHTML = '';
    text.split('').forEach(function (ch, i) {
      var span = document.createElement('span');
      span.className = 'loader-brand-char';
      span.style.setProperty('--i', i);
      span.textContent = ch === ' ' ? '\u00A0' : ch;
      brandEl.appendChild(span);
    });
  }

  /* --------------------------------------------------------
     10. INIT
     -------------------------------------------------------- */
  function init() {
    initLoaderChars();
    initLoader();
    initHeader();
    initScrollReveal();
    initParallax();
    initCursor();
    initPageTransition();
    initStatCounters();
    initCartAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
